<template lang="html">
	<div class="productSlider">
		<div class="sliderWrapper">
			<div class="container1">
				<section class="vertical-slider">
					<template v-for="item in items">
						<template v-if="item.video">
							<div v-if="item.smallImg" class="itm video">
								<img :src="item.smallImg" :alt="item.alt">
							</div>
						</template>
						<template v-else>
							<div v-if="item.smallImg" class="itm">
								<img :src="item.smallImg" :alt="item.alt">
							</div>
						</template>
					</template>
				</section>
			</div>
			<div class="container2">
				<section class="main-photo">
					<template v-for="item in items">
						<template v-if="item.video">
							<div class="item">
								<iframe :src="item.video" frameborder="0"></iframe>
							</div>
						</template>
						<template v-else>
							<a class="item" :href="item.img" v-if="item.img" data-fancybox="group">
								<img :src="item.img" :alt="item.alt">
							</a>
						</template>
					</template>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
	require('slick-carousel');
	require('__scss/slick.scss');
	require('__scss/slick-theme.scss');

	//console.log(typeof define);

	module.exports = {
		props: {
			dataParams: {
				type: String,
				required: true
			},
			dataStaticParams: {
				type: String,
				required: false
			}
		},

		data() {
			return {
				api_response: {},
				items: []
			}
		},

		computed: {
			componentParams() {
				let str = this.dataParams.replace(/'/g, '"');
				return JSON.parse(str);
			},
			staticParams() {
				let str2 = this.dataStaticParams.replace(/'/g, '"');
				return JSON.parse(str2);
			}
			// items() {
			// 	return this.api_response ? this.api_response.items : [];
			// }
		},

		watch: {
			api_response() {
				this.items = window.yamCore.sliderProduct.items;
			}
		},

	methods: {
    globalApi(){
      // console.log(window.yamCore.sliderProduct);
      window.yamCore.sliderProduct ? this.api_response = JSON.stringify(window.yamCore.sliderProduct) : this.api_response = {}
    },
    renderSlick(){
      setTimeout(function() {
        $(".main-photo").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          fade: true,
          asNavFor: '.vertical-slider'
        });
        $('.vertical-slider').slick({
          slidesToShow: 6,
          slidesToScroll: 1,
          asNavFor: '.main-photo',
          infinite: false,
          dots: false,
          arrows: false,
          vertical: true,
          verticalSwiping: true,
          focusOnSelect: true,
          onInit :  function () {
            console.log (" « слайдер был инициализирован » ");
          }
        });
      }, 0);
      setTimeout(function() {
    		$('.vertical-slider').addClass('load');
    	}, 3500);
    }
	},

  updated() {

  },

  beforeMount() {
    // this.loadAPI();
  },

  mounted() {
    this.globalApi();
    this.renderSlick();

    $(document).on('refreshSlickSlider', () => {
      this.globalApi();
      $('.vertical-slider').slick('unslick');
      $('.main-photo').slick('unslick');
      $('.vertical-slider .slick-list').remove();
      $('.main-photo .slick-list').remove();
      this.renderSlick();
    });
  }
}
</script>

<style lang="scss">
	@import "scss/wanted";

	.productSlider {
		height: 100%;
		.sliderWrapper {
			border: 1px solid #e2edf3;
			padding: 10px;
			display: flex;
			border-radius: 5px;
			border-bottom-style: dashed;
			@include m_up {
				padding: 30px;
			}
			@include l_up {
				border-right-style: dashed;
				border-bottom-style: solid;
				height: 100%;
				align-items: center;
			}
			.container1 {
				width: 83px;
				min-width: 83px;
				display: none;
				@include m_up {
					display: block;
				}
			}
			.container2 {
				width: 100%;
				padding: 0 30px;
				@include m_up {
					min-width: calc(100% - 83px);
					width: calc(100% - 83px);
				}
			}
		}
		.vertical-slider {
			border-right: 1px solid #e2edf3;
			height: 400px;
			display: none;
			pointer-events: none;
			opacity: 0;
			pointer-events: none;
			@include m_up {
				display: block;
			}
			.slick-slide {
				margin-bottom: 18px;
				&:focus, & > div {
					outline: none;
				}
				.itm {
					width: 50px !important;
					height: 50px;
					border: 1px solid #e3edf3;
					border-radius: 7px;
					background-position: center;
					background-repeat: no-repeat;
					background-size: 80%;
					@include single-transition();
					cursor: pointer;
					display: flex !important;

					&:focus, img:focus{
						outline: none;
					}
					* {
						margin: auto;
						max-width: 40px;
						max-height: 40px;
					}
					&.video {
						background-size: 100%;
						position: relative;
						&:before {
							position: absolute;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							content: "";
							background-image: url('../img/v1.png');
							background-position: center;
							background-repeat: no-repeat;
						}
					}
					&:hover {
						border-color: #dd4b39;

					}
				}
				&.slick-current {
					.itm {
						border-color: #dd4b39;
						&.video {
							// border-color: #dd4b39!important;
							// background-color: #dd4b39;
						}
					}
				}
			}
			&.load {
				pointer-events: auto;
			}
			&.slick-initialized {
				opacity: 1;
				pointer-events: auto;
			}
		}
		.main-photo {
			opacity: 0;
			pointer-events: none;
			@include m___up {
				max-height: 400px;
				overflow: hidden;
			}
			.item {
				width: 100%;
				background-position: center;
				background-repeat: no-repeat;
				background-size: contain;
				height: 258px;
				display: flex !important;
				align-items: center;
				justify-content: center;
				@include m_up {
					height: 400px;
				}
				iframe {
					width: 100%;
					height: 100%;
				}
			}
			.slick-arrow {
				background-image: url('../img/arr.svg');
				box-shadow: none;
				opacity: .7;
				width: 20px;
				@include single-transition();
				&:before {
					display: none;
				}
				&.slick-next {
					transform: rotate(-90deg);
				}
				&.slick-prev {
					transform: rotate(90deg);
				}
				&:hover {
					opacity: 1;
				}
			}
			&.slick-initialized {
				opacity: 1;
				pointer-events: auto;
				overflow: visible;
			}

		}
	}
</style>



// WEBPACK FOOTER //
// slickSlider.vue?7a44c860